module.exports = __webpack_public_path__ + "img/ProgramIcon.cb70a9ef.png";